import {
  FETCH_INDUSTRIAL_TYPES,
  FETCH_INDUSTRIAL_TYPES_SUCCESS,
  FETCH_INDUSTRIAL_TYPES_FAILED,
  EDIT_INDUSTRIAL_TYPE
} from "../store/types";
import { language } from 'config';

export const fetchIndustrialTypes = () => (dispatch) => (firebase) => {

  const {
    industrialTypesRef
  } = firebase;

  dispatch({
    type: FETCH_INDUSTRIAL_TYPES,
    payload: null
  });
  industrialTypesRef.on("value", snapshot => {
    if (snapshot.val()) {
      let data = snapshot.val();
      const arr = Object.keys(data).map(i => {
        data[i] = i;
        return data[i]
      });
      dispatch({
        type: FETCH_INDUSTRIAL_TYPES_SUCCESS,
        payload: arr
      });
    } else {
      dispatch({
        type: FETCH_INDUSTRIAL_TYPES_FAILED,
        payload: language.no_industrials
      });
    }
  });
};

export const editIndustrialType = (industrialtypes, method) => (dispatch) => (firebase) => {
  const {
    industrialTypesRef, 
    industrialTypesEditRef
  } = firebase;
  dispatch({
    type: EDIT_INDUSTRIAL_TYPE,
    payload: { method, industrialtypes }
  });
  if (method === 'Add') {
    industrialTypesRef.push(industrialtypes);
  } else if (method === 'Delete') {
    industrialTypesEditRef(industrialtypes.id).remove();
  } else {
    industrialTypesEditRef(industrialtypes.id).set(industrialtypes);
  }
}